import React, { useState, useRef, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import HrDropdown from "./component/hrdropdown";
import ReactDatePicker from "react-datepicker";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import JobDescription from "./component/job-description-dropdown";
import CommanDropdown from "../../../../components/dropdown";
import EmpoymentDetails from "./component/edit-employment-details";
import AcademicDetails from "./component/edit-academic-details";
import Accordion from "react-bootstrap/Accordion";
import AmendmentLogs from "./component/amenment-logs";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FileUploader } from "../../../../components/FileUploader";
import axios from "axios";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import validate from "./component/validate";
import {
  isCtcInputAllowed,
  validateCtc,
  toCtcAmount,
} from "../../../../utils/ctc";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";


const EditCandidate = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});
  /* Initial Form Data*/
  const initialFormData = {
    job_title: "",
    applied_date: "",
    hr: "",
    first_name: "",
    last_name: "",
    gender: "",
    email_id: "",
    dob: "",
    mobile_no: "",
    mobile_no_2: "",
    company_name: "",
    relevant_exp_in_years: "",
    ctc: "",
    referral_type: "",
    position: "",
    reason_for_change: "",
    ectc: "",
    note: "",
    experience_in_years: "",
    notice_period: "",
    notice_period_remarks: "",
    location: "",
    employment_summary: [],
    academic_details: [],
    resume: "",
    academic_row: [],
    employment_row: [],
  };
  /* Initial State To set form Data*/
  const ref = useRef();
  const [formData, setFormData] = useState(initialFormData);
  const [selectedJobTitle, setSelectedJobTitle] = useState({});
  const [activeKey, setActiveKey] = useState("0");
  const [jobtitleOption, setJobTitleOption] = useState({});
  const [hrOptions, setHrOptions] = useState([]);
  const [genderOptions, setGenderOption] = useState([]);
  const [sourceOption, setSourceOption] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    fetchCandidateDetails(id);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ctc" || name === "ectc") {
      // Only whole figures or decimals in rupees, so 820000 stays 820000
      if (!isCtcInputAllowed(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: {
            status: true,
            message:
              "Enter the amount in rupees, numbers only (e.g. 820000 or 820000.50).",
          },
        }));
        return;
      }
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      // The amount itself is checked on blur, so a half typed figure is not flagged
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: { status: false, message: "" },
      }));
      return;
    }

    // Regular expression to allow only alphabet characters
    const alphabetRegex = /^[A-Za-z]*$/;

    // Validate first_name and last_name
    if (
      (name === "first_name" || name === "last_name") &&
      !alphabetRegex.test(value)
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: { message: "Only alphabetic characters are allowed." },
      }));
      return; // Exit if the input is invalid
    } else {
      // Clear the error if input is valid
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: prevErrors[name] ? undefined : prevErrors[name],
      }));
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleCtcBlur = (e) => {
    const { name, value } = e.target;
    const label = name === "ctc" ? "CTC" : "Expected CTC";
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateCtc(value, label),
    }));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Candidate Details"));
  }, []);
  const handleDateChange = (date, name) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: moment(date).format("DD-MMM-YYYY"),
    }));
  };
  const onEmploymentDataChange = (data) => {
    formData.employment_summary = data;
  };
  const onAcademicDataChange = (data) => {
    formData.academic_details = data;
  };
  /*File uploaded Component*/
  const [fileName, setFileName] = useState(undefined);
  const handleFile = async (file) => {
    if (file) {
      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "",
        },
      }));
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        ResumePath: file.name,
      }));
      setResumeFile(file);
    } else {

      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "File size should not be exceed than 5MB.",
        },
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let mandatory_field = [
      "first_name",
      "last_name",
      "gender",
      "email_id",
      "DateOfBirth",
      "mobile_no",
      "referral_type",
      "job_title",
      "applied_date",
      "hr",
      "mobile_no_2",
      "ctc",
      "ectc",
    ];

    let isFormInvalid = false;
    // let displayedErrors = new Set();

    for (let field of mandatory_field) {
      let error = await validate([field], formData[field], formData);
      if (error.status == true) {
        isFormInvalid = true;
        // CTC can fail on format as well, so show what actually went wrong
        const isCtcField = field === "ctc" || field === "ectc";
        toast.error(
          isCtcField && error.message ? error.message : `${field} is required`
        );
      }
      setErrors((errors) => ({
        ...errors,
        [field]: error,
      }));
    }
    if (!isFormInvalid) {
      setSubmit(true);
      const url = API_URL + "candidateprocess/" + id;
      formData.ID = id;
      formData.hr = formData.hr?.value;
      formData.job_title = formData.job_title?.value;
      formData.resumeFile = resumeFile;
      let response = await PostFormServiceCaller(url, formData, "put");
      if (response.data.status === "success") {
        navigate("/candidate-in-process");
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      setSubmit(false);
    }
  };
  const fetchCandidateDetails = async (id) => {
    const url = API_URL + "candidateprocess/" + id;
    let response = await GetServiceCaller(url);

    let candidateDetails = response?.data?.data?.candidate_details[0];
    const jobtitleOption = response?.data?.data?.job_titles.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    let selectedJobTitle = jobtitleOption.find(
      (o) => o.value == candidateDetails?.JobMasterID
    );
    setJobTitleOption([{ value: "", label: "Select..." }, ...jobtitleOption]);

    const hrOptions = response?.data?.data?.hr?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setHrOptions([{ value: "", label: "Select..." }, ...hrOptions]);
    // gender option
    const genderOpt = response?.data?.data?.gender?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setGenderOption([{ value: "", label: "Select..." }, ...genderOpt]);

    // source option
    const sourceOpt = response?.data?.data?.source?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setSourceOption([{ value: "", label: "Select..." }, ...sourceOpt]);

    let selectedHr = hrOptions.find(
      (o) => o.value == candidateDetails?.RecruiterID
    );

    let selected_gender = genderOpt.find(
      (o) => o.value == candidateDetails?.Gender_020
    );
    let selected_source = sourceOpt.find(
      (o) => o.value == candidateDetails?.CandidateReferralType_174
    );

    let fetchCandidateDetails = {
      job_title: selectedJobTitle,
      applied_date: moment(candidateDetails?.AppliedDate).format("DD-MMM-YYYY"),
      hr: selectedHr,
      first_name: candidateDetails?.FirstName,
      last_name: candidateDetails?.LastName,
      gender: selected_gender,
      email_id: candidateDetails?.EmailID,
      dob: moment(candidateDetails?.DateOfBirth).format("DD-MMM-YYYY"),
      mobile_no: candidateDetails?.MobileNo,
      mobile_no_2: candidateDetails?.MobileNo1,
      company_name: candidateDetails?.CurrentCompanyName,
      relevant_exp_in_years: Number(
        candidateDetails?.CurrentRelevantExperienceInYears
      ).toFixed(0),
      ctc: toCtcAmount(candidateDetails?.CurrentCTC),
      referral_type: selected_source,
      position: candidateDetails?.CurrentPosition,
      reason_for_change: candidateDetails?.ReasonForChange,
      ectc: toCtcAmount(candidateDetails?.ExpectedCTC),
      experience_in_years: Number(
        candidateDetails?.CurrentExperienceInYears
      ).toFixed(0),
      notice_period: candidateDetails?.NoticePeriod,
      notice_period_remarks: candidateDetails?.NoticePeriodRemarks,
      location: candidateDetails?.CurrentLocation,
      resume: candidateDetails?.ResumePath,
      ResumeBasePath: candidateDetails?.ResumeBasePath,
      note: candidateDetails?.ReferralNote,
      employment_summary: employmentDetails(response.data.employment),
      academic_details: academicDetails(response.data.academic),
      academic_row: response.data.academic,
      employment_row: response.data.employment,
      ResumePath: candidateDetails.ResumePath,
    };
    setFormData(fetchCandidateDetails);
    setFormData(fetchCandidateDetails);
    setFormData(fetchCandidateDetails);

    setPageLoading(false);
  };
  const employmentDetails = (values) => {
    let initialRoleFormData = {
      company: [],
      position: [],
      location: [],
      from_date: [],
      to_date: [],
    };
    if (values) {
      for (let row of values) {
        initialRoleFormData.company.push(row.CompanyName);
        initialRoleFormData.position.push(row.Position);
        initialRoleFormData.location.push(row.Location);
        initialRoleFormData.from_date.push(row.FromDate);
        initialRoleFormData.to_date.push(row.ToDate);
      }
    }
    return initialRoleFormData;
  };
  const academicDetails = (values) => {
    let initialRoleFormData = {
      unviersity: [],
      institute: [],
      degree: [],
      degree_info_disable: [],
      degree_info: [],
      passing_year: [],
    };
    if (values) {
      for (let row of values) {
        initialRoleFormData.unviersity.push(row.University);
        initialRoleFormData.institute.push(row.Institute);
        initialRoleFormData.degree.push(row.Degree_152);
        initialRoleFormData.degree_info_disable.push(
          row.DegreeInfo == "" ? true : false
        );
        initialRoleFormData.degree_info.push(row.DegreeInfo);
        initialRoleFormData.passing_year.push(row.PassingYear.toString());
      }
    }
    return initialRoleFormData;
  };
  const handleDropdownChange = (e, name) => {
    const { value } = typeof e?.target == "undefined" ? e : e?.target;
    setFormData({
      ...formData,
      [name]: typeof e?.target == "undefined" ? e : value,
    });
    setErrors((errors) => ({
      ...errors,
      [name]: {},
    }));
  };

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form
            id="formOne"
            className="rounded mt-2 bg-white"
            onSubmit={handleSubmit}
          >
            <div className="container-fluid p-0">
              {/* tab code start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="job-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#job"
                    type="button"
                    role="tab"
                    aria-controls="job"
                    aria-selected="true"
                  >
                    Job Details
                    <span className="text-Primary">
                      {formData.job_title?.label &&
                        `: ${formData.job_title.label}`}
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="personal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-controls="personal"
                    aria-selected="false"
                  >
                    Personal Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="project-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#project"
                    type="button"
                    role="tab"
                    aria-controls="project"
                    aria-selected="false"
                  >
                    Company Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="rating-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#rating"
                    type="button"
                    role="tab"
                    aria-controls="rating"
                    aria-selected="false"
                  >
                    Amendment Log
                  </button>
                </li>
              </ul>
              {/* tab main section code start */}
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="job"
                  role="tabpanel"
                  aria-labelledby="job-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Job Title <span className="required">*</span>
                        </label>

                        <Select
                          options={jobtitleOption}
                          onChange={(selected) => {
                            handleDropdownChange(selected, "job_title");
                          }}
                          selected={selectedJobTitle}
                          value={formData.job_title}
                          name="job_title"
                        />
                        {errors?.job_title?.status && (
                          <span class="error">
                            {errors?.job_title?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Applied Date<span className="required">*</span>
                        </label>
                        <ReactDatePicker
                          minDate={new Date()}
                          changeYear
                          changeMonth
                          showPopperArrow
                          showIcon
                          icon="fa fa-calendar"
                          className="form-control"
                          placeholderText="Applied Date"
                          format="d-MM-YYYY"
                          name="applied_date"
                          id="applied_date"
                          value={formData.applied_date}
                          onChange={(date) => {
                            handleDateChange(date, "applied_date");
                          }}
                        />

                        {errors?.applied_date?.status && (
                          <span class="error">
                            {errors?.applied_date?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          HR Name <span className="required">*</span>
                        </label>
                        <Select
                          onChange={(selected) => {
                            handleDropdownChange(selected, "hr");
                          }}
                          value={formData.hr}
                          name="hr"
                          options={hrOptions}
                        />

                        {errors?.hr?.status && (
                          <span class="error">{errors?.hr?.message}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Personal Detail section  */}
                <div
                  className="tab-pane fade show"
                  id="personal"
                  role="tabpanel"
                  aria-labelledby="personal-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row mt-2">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          First Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          placeholder="First Name"
                          value={formData.first_name}
                          onChange={handleChange}
                        />
                        {errors?.first_name?.status && (
                          <span class="error">
                            {errors?.first_name?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Last Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          placeholder="Last Name"
                          value={formData.last_name}
                          onChange={handleChange}
                        />
                        {errors?.last_name?.status && (
                          <span class="error">
                            {errors?.last_name?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Gender<span className="required">*</span>
                        </label>
                        <Select
                          name="gender"
                          options={genderOptions}
                          value={formData.gender}
                          onChange={(e) => handleDropdownChange(e, "gender")}
                        />

                        {errors?.gender?.status && (
                          <span class="error">{errors?.gender?.message}</span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Email ID<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="email_id"
                          placeholder="Email"
                          value={formData.email_id}
                          onChange={handleChange}
                        />

                        {errors?.email_id?.status && (
                          <span class="error">{errors?.email_id?.message}</span>
                        )}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          DOB<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          handleChange={handleChange}
                          value={formData.dob}
                          name="dob"
                          id="DateOfBirth"
                          className="form-control"
                          placeholderText="Date Of Birth"
                          maxDate={new Date()}
                        ></CustomDatePicker>

                        {errors?.dob?.status && (
                          <span class="error">{errors?.dob?.message}</span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Contact No.<span className="required">*</span>
                        </label>
                        {/* <input
                          maxLength={10}
                          minLength={10}
                          type="text"
                          className="form-control"
                          name="mobile_no"
                          placeholder="Mobile No"
                          value={formData.mobile_no}
                          onChange={handleChange}
                        /> */}
                        <input
                       className="form-control"
                          name="mobile_no"
                          type="number"
                          value={
                            formData.mobile_no
                              ? formData.mobile_no
                              : ""
                          }
                          // onChange={(phone) => {
                          //   const isValid = phone && phone.length > 4;
                          //   setFormData({
                          //     ...formData,
                          //     mobile_no: isValid ? phone : "",
                          //   });
                          //   setErrors((errors) => ({
                          //     ...errors,
                          //     mobile_no: isValid ? "" : "Invalid phone number",
                          //   }));
                          // }}
                           onChange={handleChange}
                          placeholder="Contact No."
                        />
                        {errors?.mobile_no?.status && (
                          <span class="error">
                            {errors?.mobile_no?.message}
                          </span>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Alternate Contact No.
                        </label>
                        {/* <input
                          maxLength={10}
                          minLength={10}
                          type="text"
                          className="form-control"
                          name="mobile_no_2"
                          placeholder="Alternate Mobile No"
                          value={formData.mobile_no_2}
                          onChange={handleChange}
                        /> */}
                        <input
                          // defaultCountry="in"
                          type="number"
                          className="form-control"
                          name="mobile_no_2"
                          value={
                            formData.mobile_no_2
                              ? formData.mobile_no_2
                              : ""
                          }
                          // onChange={(phone) => {
                          //   const isValid = phone && phone.length > 4;
                          //   setFormData({
                          //     ...formData,
                          //     mobile_no_2: isValid ? phone : "",
                          //   });
                          // }}
                          onChange={handleChange}
                          placeholder="Contact No."
                        />
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div>
                          <FileUploader handleFile={handleFile}  fileTypes={["image/jpeg", "image/png", "image/gif","application/pdf"]}/>

                          {formData.ResumePath || fileName ? (
                            <p>
                              Resume:{" "}
                              <a target="_blank" href={formData.ResumeBasePath}>
                                {fileName ? fileName : formData.ResumePath}
                              </a>
                            </p>
                          ) : null}

                          {errors?.resume?.status && (
                            <span class="error">{errors?.resume?.message}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Company Detail Section */}
                <div
                  className="tab-pane fade show"
                  id="project"
                  role="tabpanel"
                  aria-labelledby="project-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row mt-2">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_name"
                          placeholder="Company Name"
                          value={formData.company_name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Position</label>
                        <input
                          type="text"
                          className="form-control"
                          name="position"
                          placeholder="Position"
                          onChange={handleChange}
                          value={formData.position}
                        />
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Source<span className="required">*</span>
                        </label>
                        <Select
                          name="referral_type"
                          options={sourceOption}
                          value={formData.referral_type}
                          onChange={(e) =>
                            handleDropdownChange(e, "referral_type")
                          }
                          placeholder="Source"
                        />

                        {errors?.referral_type?.status && (
                          <span class="error">
                            {errors?.referral_type?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Location</label>
                        <input
                          type="text"
                          className="form-control"
                          name="location"
                          placeholder="Location"
                          value={formData.location}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6 col-lg-3">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="MinExperience"
                            className="form-label  "
                          >
                            Experience
                          </label>
                          <div className="row">
                            <div className="col-sm-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Exp in Yrs
                                  </Tooltip>
                                }
                              >
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="experience_in_years"
                                  placeholder="Experience In Year"
                                  value={formData.experience_in_years}
                                  onChange={handleChange}
                                />
                              </OverlayTrigger>
                            </div>
                            <div className="col-sm-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Relevant Exp in Yrs
                                  </Tooltip>
                                }
                              >
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="relevant_exp_in_years"
                                  placeholder="Experience"
                                  value={formData.relevant_exp_in_years}
                                  onChange={handleChange}
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-3">
                        <div className="d-flex flex-column">
                          <label htmlFor="MinExperience" className="form-label">
                            CTC (in Rupees)
                            <span className="text-danger">*</span>
                          </label>
                          <div className="row">
                            <div className="col-sm-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    CTC (in Rupees, e.g. 820000)
                                  </Tooltip>
                                }
                              >
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  className="form-control text-end"
                                  name="ctc"
                                  placeholder="e.g. 820000"
                                  value={formData.ctc}
                                  onChange={handleChange}
                                  onBlur={handleCtcBlur}
                                />
                              </OverlayTrigger>
                              {errors?.ctc?.status && (
                                <span className="error">
                                  {errors?.ctc?.message}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Expected CTC (in Rupees, e.g. 820000)
                                  </Tooltip>
                                }
                              >
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  className="form-control text-end"
                                  name="ectc"
                                  placeholder="e.g. 900000"
                                  value={formData.ectc}
                                  onChange={handleChange}
                                  onBlur={handleCtcBlur}
                                />
                              </OverlayTrigger>
                              {errors?.ectc?.status && (
                                <span className="error">
                                  {errors?.ectc?.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Notes</label>
                        <input
                          type="text"
                          className="form-control"
                          name="note"
                          placeholder="Note"
                          value={formData.note}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Reason For Change</label>
                        <textarea
                          className="form-control"
                          name="reason_for_change"
                          placeholder="Reason For Change"
                          onChange={handleChange}
                          value={formData.reason_for_change}
                        >
                          {formData.reason_for_change}
                        </textarea>
                      </div>
                    </div>
                    <div className="row">
                      {/* <div className="col-md-6 col-lg-3">
                        <label className="form-label">Notice Period</label>
                        <input
                          type="text"
                          className="form-control text-end"
                          name="notice_period"
                          placeholder="Notice Period"
                          value={formData.notice_period}
                          onChange={handleChange}
                        />
                      </div> */}
                      <div className="col-md-6 col-lg-3">
                        <div className="d-flex flex-column">
                          <label
                            htmlFor="notice_period"
                            className="form-label  "
                          >
                            Notice Period
                          </label>
                          <div className="row">
                            <div className="col-sm-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Notice Period in Days
                                  </Tooltip>
                                }
                              >
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="notice_period"
                                  placeholder="Notice Period"
                                  value={formData.notice_period}
                                  onChange={handleChange}
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">Notice Period Remarks</label>
                        <input
                          type="text"
                          className="form-control"
                          name="notice_period_remarks"
                          placeholder="Notice Period Remarks"
                          value={formData.notice_period_remarks}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Amendment Log Section */}
                <div
                  className="tab-pane fade show"
                  id="rating"
                  role="tabpanel"
                  aria-labelledby="rating-tab"
                >
                  <div className="container-fluid mt-2">
                    <AmendmentLogs candidateID={id} />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="d-flex justify-content-between">
                    <div></div>
                    <div className="d-flex">
                      <div>
                            <button 
      className="cancel-btn me-2" 
      onClick={() => navigate('/candidate-in-process')}
    >
      Cancel
    </button>
                      </div>
                      <div>
                        <button
                          disabled={submitted ? true : false}
                          onClick={handleSubmit}
                          type=""
                          className="custom-btn"
                        >
                          {submitted ? (
                            <FaSpinner class="sm-spinner" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
};

export default EditCandidate;
